:host {
  // storybook-spinner - START

  .spinner {
    position: fixed;
    top: 50%;
    left: calc(50% - 50px);
    border-radius: 50%;
    cursor: progress;
    -webkit-transition: all 200ms ease-out;
    transition: all 200ms ease-out;
    vertical-align: top;
    height: 100px;
    width: 100px;
    z-index: 200;
    border-width: 2px;
    border-style: solid;
    border-color: rgba(97, 97, 97, 0.29);
    border-top-color: rgb(100, 100, 100);
    -webkit-animation: spinner-animation 0.7s linear infinite;
    animation: spinner-animation 0.7s linear infinite;
    mix-blend-mode: difference;
  }

  @keyframes spinner-animation {
    0% {
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  // storybook-spinner - END

  .isLoading::after {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    width: 100vw;
    height: 100vh;
    z-index: 150;
    background-color: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(5px);
  }
}

.modal {
  font-family: var(--primary-font);
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: auto;
  background: rgba(0, 0, 0, 0.4);
  @include layerIndex('modal');

  &.open {
    display: block;
  }

  &-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &-content {
    background: var(--color-white);
    margin: auto;
    width: 100%;
    max-width: 992px;
    position: relative;
    @include layerIndex('modal');
    min-height: 100%;

    @include breakpointMin('lg') {
      margin-top: 100px;
      margin-bottom: 100px;
      min-height: auto;
    }

    .modal-header {
      position: sticky;
      top: 0;
      z-index: 9999;

      &.close-btn-svg {

        .close {
          background-color: var(--color-bleached-silk);
          aspect-ratio: 1;
          width: 38px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          border: none;

          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }

  &.login-modal .modal-content {
    max-width: 450px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;

    @media (min-width: 576px) {
      padding: 5px 25px 20px 25px;
    }
  }

  &-body {
    padding: 15px;

    @media (min-width: 576px) {
      padding: 0 35px 20px 35px;
    }
  }

  .close {
    --close-btn-height: 36px;
    position: relative;
    background: var(--color-bleached-silk);
    border-radius: 50%;
    width: 36px;
    height: var(--close-btn-height);
    aspect-ratio: 1 / 1;
    border: 1px solid var(--color-bleached-silk);
    margin-top: 18px;
    text-align: center;
    line-height: var(--close-btn-height);
  }

  .close:hover,
  .close:focus {
    cursor: pointer;
    opacity: 0.7;
  }

  .msg {
    text-align: center;
    padding-bottom: 50px;
    padding-top: 25px;
  }

  ::slotted([slot='title']) {
    margin-bottom: 20px;
  }

  &.filter {
    .modal-content {
      .modal-header {
        padding: 10px 20px 0px 20px;
      }

      .modal-body {
        padding: 5px 20px 20px 20px;
      }
    }

    @include breakpointMin('lg') {
      position: unset;
      display: block;
      @include layerIndex('ground');

      .modal-overlay {
        display: none;
      }

      .modal-content {
        margin: unset;
        @include layerIndex('ground');
        overflow: hidden;

        .modal-header {
          display: none;
        }

        .modal-body {
          padding: unset;
        }
      }
    }
  }

  &.lightbox {
    --modal-left-right-padding: 0;

    @include breakpointMin('xl') {
      --modal-left-right-padding: 80px;
    }

    .modal-content {
      position: fixed;
      left: calc(var(--modal-left-right-padding) / 2);
      width: 100%;
      max-width: calc(100% - var(--modal-left-right-padding));
      height: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }

  &.energy-efficiency {
    .modal-body {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @include breakpointMin('lg') {
      .modal-content {
        max-width: 500px;
      }
    }

    ::slotted(lilu-img) {
      height: 70vh;
      width: 100%;
      object-fit: contain;
      display: flex;
    }
  }


  &.google-ads .modal-content {
    @include breakpointMax('x') {
      max-height: 90vh;
      height: auto;
      min-height: unset;
      top: 30%;
      transform: translateY(-30%);
    }
  }

}

::slotted([slot='button']) {
  cursor: pointer;
}
